// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRoleResponse
 */
export interface UserRoleResponse {
    /**
     * 
     * @type {string}
     * @memberof UserRoleResponse
     */
    oid: string;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResponse
     */
    role: string;
    /**
     * 
     * @type {Date}
     * @memberof UserRoleResponse
     */
    addedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResponse
     */
    addedBy: string;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResponse
     */
    email?: string | null;
}

/**
 * Check if a given object implements the UserRoleResponse interface.
 */
export function instanceOfUserRoleResponse(value: object): value is UserRoleResponse {
    if (!('oid' in value) || value['oid'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('addedAt' in value) || value['addedAt'] === undefined) return false;
    if (!('addedBy' in value) || value['addedBy'] === undefined) return false;
    return true;
}

export function UserRoleResponseFromJSON(json: any): UserRoleResponse {
    return UserRoleResponseFromJSONTyped(json, false);
}

export function UserRoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRoleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'oid': json['oid'],
        'role': json['role'],
        'addedAt': (json['added_at'] == null ? null : new Date(json['added_at'])),
        'addedBy': json['added_by'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function UserRoleResponseToJSON(json: any): UserRoleResponse {
    return UserRoleResponseToJSONTyped(json, false);
}

export function UserRoleResponseToJSONTyped(value?: UserRoleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oid': value['oid'],
        'role': value['role'],
        'added_at': value['addedAt'] == null ? value['addedAt'] : value['addedAt'].toISOString(),
        'added_by': value['addedBy'],
        'email': value['email'],
    };
}

